export const CARE_DIMENSIONS = [
  { id: "mood", title: "Mood & Engagement", icon: "😊" },
  { id: "medication", title: "Medication Adherence", icon: "💊" },
  { id: "mobility", title: "Mobility & Function", icon: "🚶" },
  { id: "nutrition", title: "Nutrition & Hydration", icon: "🥗" },
  { id: "cognition", title: "Cognitive Health", icon: "🧠" },
  { id: "social", title: "Social Engagement", icon: "👥" },
  { id: "environment", title: "Environment & Home Safety", icon: "🏠" },
  { id: "overall", title: "Overall Wellness", icon: "✨" },
];

const LEVEL_LABELS = {
  great: "Great",
  good: "Good",
  okay: "Okay",
  needs_attention: "Needs attention",
  all_taken: "All taken",
  some_taken: "Some taken",
  none_taken: "None taken",
  not_reported: "Not reported",
  excellent: "Excellent",
  no_concerns: "No concerns reported",
  minor_concerns: "Minor concerns",
  requires_attention: "Requires attention",
  immediate_attention: "Immediate attention",
};

const LEVEL_TONE = {
  great: "great",
  good: "good",
  okay: "okay",
  all_taken: "good",
  some_taken: "okay",
  none_taken: "alert",
  needs_attention: "alert",
  not_reported: "muted",
  excellent: "great",
  no_concerns: "great",
  minor_concerns: "okay",
  requires_attention: "alert",
  immediate_attention: "alert",
};

export function formatCareLevel(value) {
  const key = String(value || "not_reported").toLowerCase();
  return {
    key,
    label: LEVEL_LABELS[key] || "Not reported",
    tone: LEVEL_TONE[key] || "muted",
  };
}

export function formatVisitDate(value) {
  if (!value) return "—";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString(undefined, {
    weekday: "short",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
  });
}
